export const stopMailLinksAndOpenEmail = () => {
    const mailLinks = document.querySelectorAll('.mail-current-page');
    console.log(mailLinks);

    
  
    /*mailLinks.forEach(link => {
        console.log('ouuoouuoouououuoououou');
        link.classList.add('oudodooooooooo');
        link.preventDefault();
      link.addEventListener('click', event => {
        event.preventDefault();
        const currentPageUrl = window.location.href;
        const emailSubject = 'Check out this link';
        const emailAddress = 'mailto:?subject=' + encodeURIComponent(emailSubject) + '&body=' + encodeURIComponent(currentPageUrl);
        window.location.href = emailAddress;
        console.log('ouuoouuoouououuoououou');
      });
    });*/

  };